// expressed as multipliers of theme.spacing
export var Spacing;
(function (Spacing) {
    Spacing[Spacing["xxsmall"] = 0.25] = "xxsmall";
    Spacing[Spacing["xsmall"] = 0.5] = "xsmall";
    Spacing[Spacing["small"] = 1] = "small";
    Spacing[Spacing["small12"] = 1.5] = "small12";
    Spacing[Spacing["base"] = 2] = "base";
    Spacing[Spacing["large"] = 3] = "large";
    Spacing[Spacing["xlarge"] = 4] = "xlarge";
    Spacing[Spacing["xxlarge"] = 5] = "xxlarge";
})(Spacing || (Spacing = {}));
// expressed as pixel values
export var SpacingPixel;
(function (SpacingPixel) {
    SpacingPixel[SpacingPixel["xxsmall"] = 2] = "xxsmall";
    SpacingPixel[SpacingPixel["xsmall"] = 4] = "xsmall";
    SpacingPixel[SpacingPixel["small"] = 8] = "small";
    SpacingPixel[SpacingPixel["small12"] = 12] = "small12";
    SpacingPixel[SpacingPixel["base"] = 16] = "base";
    SpacingPixel[SpacingPixel["large"] = 24] = "large";
    SpacingPixel[SpacingPixel["xlarge"] = 32] = "xlarge";
    SpacingPixel[SpacingPixel["xxlarge"] = 40] = "xxlarge";
})(SpacingPixel || (SpacingPixel = {}));
